import { AfterViewInit, Component, OnInit, ViewChild, ElementRef, Input, HostListener } from "@angular/core";
import { Router } from "@angular/router";
import { Actions } from "@ngrx/effects";
import { select, Store } from "@ngrx/store";
import { take, takeUntil, tap } from "rxjs/operators";
import { ProUser } from "src/app/models/pro-user";
import { AuthService } from "src/app/services/auth.service";
import { AddToCart, CartActionTypes, GetCart, GetCartSuccess, ItemDeletedFromCart, OpenCart } from "src/app/store/actions/cart.actions";
import { Logout, SetEzPayStatus, SetUser, UserActionTypes } from "src/app/store/actions/user.actions";
import { selectUser } from "src/app/store/selectors/user.selectors";
import { IAppState } from "src/app/store/state/app.state";
import jwt_decode from "jwt-decode";
import { VendorShort } from "src/app/models/vendor/vendor";
import { SiteService } from "src/app/services/site.service";
import { AutoUnsubscribeMixin } from "src/app/mixins/auto-unsubscribe.mixin";
import { CloseQuickAdd, CloseSearch, CloseSideNav, HideUploadOrder, OpenQuickAdd, OpenSearch, OpenSideNav, SetNavMenuOpen, SetUndoMessage, SiteActionTypes, SuccessMessageSet, ShowUploadOrder } from "src/app/store/actions/site.actions";
import { UndoMessage } from "src/app/models/dashboard/undo-message";
import { SubscriptionLike, timer } from "rxjs";
import { DataService } from "src/app/services/data.service";
import { Permissions } from "src/app/modules/controls/enums/permissions";
import { UploadOrderItemError } from "src/app/models/shopping/product";
import { ChangeDetectorRef } from '@angular/core';
import * as XLSX from 'xlsx';



@Component({
	selector: "app-template",
	templateUrl: "./template.component.html",
	styleUrls: ["./template.component.scss"],
})

export class TemplateComponent extends AutoUnsubscribeMixin() implements OnInit, AfterViewInit {
  @ViewChild('uploadOrderFileField') uploadFileFormField: ElementRef;


  public today: Date = new Date();
	public showSideCart: boolean = false;
	public cartQuantity: number = 0;
	public user: ProUser;
	public loaderVisible: boolean = false;
	public sidebarVisible: boolean = false;
	public showDashboardSubmenu: boolean = false;
	public showSearchDialog: boolean = false;
	public showQuickAdd: boolean = false;
	public showItemDeleted: boolean = false;
	public showUndoMessage: boolean = false;
	public showUploadOrder: boolean = false;
	public uploadOrderType: number = 0;
	public undoMessage: UndoMessage;
	public currentOpenMenu: string = '';
	public message: string = '';
	public messageType: 'success' | 'error';
	public ezPayText: 'EZPay' | 'PromptPay' | '' = '';
	public removeText: string = '';
  public isMobileView = window.innerWidth <= 768;
  public uploadInProgress = false;
  public uploadProgress = 0;
  public uploadPhase: 'idle' | 'lookup' | 'processing' | 'complete' = 'idle';
 /* @HostListener('window:resize', [])*/
/*  @HostListener('document:click', ['$event'])*/
  public currentProductCode: string = '';
  private lookupInterval: any;


  public _loaderIds: Array<{ key: string; observable: SubscriptionLike }> = [];

  private activeHoverGroup = new Set(['dashboard', 'sidebar']);
  
	private lastDeletedItem: {productCode: string, quantity: number};
	
  public recentVendors: Array<VendorShort>;

	public uploadOrderTypeOptions = [
		{ label: 'Product Code, Quantity', value: 0 },
		{ label: 'Quantity, Product Code', value: 1 }
	];
	public uploadErrors: Array<any> = [];
	public Permissions = Permissions;
  public disallowed: boolean = false;
  public flyoutOpen = false;

  hoveredMain: string | null = null;
  closeTimeout: any;
  activeMain: string = 'dashboard'; // Example: set active item here
  hoverTimeout: any = null;
  private isHovering = false;

	constructor(
		private actions$: Actions, 
		private store: Store<IAppState>, 
		private router: Router, 
		private authService: AuthService, 
		private siteService: SiteService,
    private dataService: DataService,
    private cdRef: ChangeDetectorRef
	) { super(); }

  ngOnInit(): void {




		let user = this.authService.user;
		this.actions$
			.pipe(
				tap((a) => {
					switch (a.type) {
						case CartActionTypes.OPEN_CART:
							this.showSideCart = true;
							break;
						case CartActionTypes.CLOSE_CART:
							this.showSideCart = false;
							break;
						case CartActionTypes.GET_CART_SUCCESS:
							if((a as GetCartSuccess).cart?.cartItems) {
								this.cartQuantity = (a as GetCartSuccess).cart.cartItems.reduce((a, b) => a + b.quantity, 0) + (a as GetCartSuccess).cart.cartBundles.reduce((a, b) => a + b.quantity, 0);
							}
							break;
						case SiteActionTypes.OPEN_SEARCH:
							this.showSearchDialog = true;
							break;
						case SiteActionTypes.CLOSE_SEARCH:
							this.showSearchDialog = false;
							break;
						case SiteActionTypes.OPEN_SIDE_NAV:
							this.sidebarVisible = true;
							//setTimeout(() => document.getElementsByTagName('body')[0].addEventListener('click', this.closeSideNav.bind(this), true), 500);
							break;
						case SiteActionTypes.CLOSE_SIDE_NAV:
							this.sidebarVisible = false;
							this.showDashboardSubmenu = false;
							//document.getElementsByTagName('body')[0].removeEventListener('click', this.closeSideNav.bind(this), true)
							setTimeout(() => document.getElementsByClassName('p-sidebar-mask')[0]?.remove(), 250); //primeng bug, need to make sure this happens
							break;
						case CartActionTypes.ITEM_DELETED_FROM_CART:
							this.lastDeletedItem = {productCode: (a as ItemDeletedFromCart).productCode, quantity: (a as ItemDeletedFromCart).quantity };
							this.showItemDeleted = true;
							break;
						case SiteActionTypes.SET_NAV_MENU_OPEN:
							this.currentOpenMenu = (a as SetNavMenuOpen).menu;
							break;
						case SiteActionTypes.NAVIGATING:
							this.showItemDeleted = false;
							this.showDashboardSubmenu = false;
							this.loaderVisible = false;
							break;
						case SiteActionTypes.SET_UNDO_MESSAGE:
							this.undoMessage = (a as SetUndoMessage).undoMessage;
							this.showUndoMessage = (this.undoMessage != undefined);
							break;
						case SiteActionTypes.SHOW_UPLOAD_ORDER:
							this.showQuickAdd = false;
							setTimeout(() => document.getElementsByClassName('p-sidebar-mask')[0]?.remove(), 250); //primeng bug, need to make sure this happens
							this.showUploadOrder = true;
							break;
						case SiteActionTypes.HIDE_UPLOAD_ORDER:
							this.showUploadOrder = false;
							this.uploadErrors = [];
							this.uploadFileFormField.nativeElement.value = null;
							break;
						case UserActionTypes.SET_EZPAY_STATUS:
							this.ezPayText = (a as SetEzPayStatus).status == 1 ? 'EZPay' : ((a as SetEzPayStatus).status == 3 ? 'PromptPay' : '');
							break;
						case SiteActionTypes.OPEN_QUICK_ADD:
							this.showQuickAdd = true;
							break;
						case SiteActionTypes.CLOSE_QUICK_ADD:
							this.showQuickAdd = false;
					}
				})
			)
			.subscribe();
		this.store.pipe(select(selectUser), takeUntil(this.destroy$)).subscribe((u) => {
			if(u) {
				this.user = u;
			} else {
				if(this.authService.token) {
					this.store.dispatch(new SetUser(new ProUser(jwt_decode(this.authService.token))))
				}
			}
		});
		if(this.authService.isLoggedIn) {
			this.store.dispatch(new GetCart());
			this.dataService.getEzPayStatus().subscribe(resp => this.store.dispatch(new SetEzPayStatus(resp)))
		}

		this.recentVendors = this.siteService.getRecentVendors();
		this.siteService.onSetLoaderVisible.subscribe(v => this.loaderVisible = v)

		this.siteService.onDisallow.pipe(takeUntil(this.destroy$)).subscribe(d => this.disallowed = d)
	}



	ngAfterViewInit(): void {
		this.siteService.onShowLoader.pipe(takeUntil(this.destroy$)).subscribe((id) => {
			if (this._loaderIds.filter((l) => l.key == id).length > 0) {
				//if hide has already fired...
				return;
			}
			let obs = timer(1000);
			this._loaderIds.push({
				key: id,
				observable: obs.pipe(take(1)).subscribe((val) => {
					this.loaderVisible = true;
				}),
			});
		});
		this.siteService.onHideLoader.pipe(takeUntil(this.destroy$)).subscribe((id) => {
			let ldr = this._loaderIds.filter((o) => o.key == id);
			if (ldr.length > 0) {
				if (ldr[0].observable) {
					ldr[0].observable.unsubscribe();
				}
				ldr[0].observable = null;
			} else {
				this._loaderIds.push({ key: id, observable: null });
			}

			if (this._loaderIds.filter((x) => x.observable != null).length == 0) {
				this.loaderVisible = false;
			}
			this._loaderIds = this._loaderIds.filter(o => o.key != id)
		});
	}
	openCart() {
		this.store.dispatch(new OpenCart());
	}

  handleClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (this.isMobile() && this.flyoutOpen && !target.closest('.has-flyout')) {
      this.flyoutOpen = false;
    }
  }

  toggleFlyout(event: MouseEvent) {
    event.stopPropagation();
    this.flyoutOpen = !this.flyoutOpen;
  }

  openFlyout() {
    this.flyoutOpen = true;
  }

  closeFlyout() {
    this.flyoutOpen = false;
  }


  isMobile(): boolean {
    return window.innerWidth <= 768;
  }

  @HostListener('window:resize', [])
  onResize() {
    this.isMobileView = window.innerWidth <= 768;
    if (!this.isMobileView && this.flyoutOpen) {
      this.flyoutOpen = false;
    }
  }


  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (this.isMobile() && this.flyoutOpen && !target.closest('.has-flyout')) {
      this.flyoutOpen = false;
    }
  }


  onMouseEnter(section: string) {
    clearTimeout(this.hoverTimeout);
    this.hoveredMain = section;
  }

  onMouseLeave(section: string) {
    this.hoverTimeout = setTimeout(() => {
      if (section === 'dashboard' || section === 'submenu') {
        // Only close the submenu
        if (this.hoveredMain === 'dashboard' || this.hoveredMain === 'submenu') {
          this.hoveredMain = 'sidebar'; // Keep sidebar open
        }
      } else if (section === 'sidebar') {
        // Leaving entire sidebar closes everything
        this.hoveredMain = '';
      }
    }, 500);
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    const dropzone = (event.currentTarget as HTMLElement);
    dropzone.classList.add('drag-over');
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    const dropzone = (event.currentTarget as HTMLElement);
    dropzone.classList.remove('drag-over');
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    const dropzone = (event.currentTarget as HTMLElement);
    dropzone.classList.remove('drag-over');

    const file = event.dataTransfer?.files?.[0];
    if (file) {
      const fakeEvent = {
        target: {
          files: [file]
        }
      };
      this.upload(fakeEvent as any);
    }
  }

  startCloseTimer() {
    this.closeTimeout = setTimeout(() => {
      this.hoveredMain = null;
    }, 1500); // delay in ms
 
  }

  cancelCloseTimer() {
    clearTimeout(this.closeTimeout);
  }



	openDashboardSubmenu(e) {
		this.showDashboardSubmenu = true;
		e.stopPropagation()
	}
	openSearch() {
		this.store.dispatch(new OpenSearch(7));
  }

  openSearchMobile() {
    this.store.dispatch(new OpenSearch(4));
  }


	openQuickOrder() {
		this.store.dispatch(new OpenQuickAdd())
	}
	onSideNavHide() {
		this.showDashboardSubmenu = false;
	}
	vendorSelected(v:VendorShort) {
		this.siteService.addRecentVendor(v);
		this.recentVendors = this.siteService.getRecentVendors();  //should be observable
		this.router.navigate(['/vendor', v.vendorId])
	}

	closeSearch() {
		this.store.dispatch(new CloseSearch());
	}
	logout() {
		this.authService.logout();
		this.store.dispatch(new Logout());
		this.router.navigate(['/login']);
	}

	undoDelete() {
		if(!this.lastDeletedItem) return;
		this.store.dispatch(new AddToCart(this.lastDeletedItem.productCode, 1));
		this.showItemDeleted = false;
	}
	openMenu(menu) {
		if(menu == this.currentOpenMenu) {
			menu = ''; //clicking again to close
		}
		this.store.dispatch(new SetNavMenuOpen(menu));
	}
	doUndo(callback, parameters) {
		callback(parameters);
	}
	closeSideNav() {
		if(this.sidebarVisible) {
			this.store.dispatch(new CloseSideNav())
		}
	}
	openSideNav() {
		this.store.dispatch(new OpenSideNav())
	}
	closeUploadOrder() {
		this.store.dispatch(new HideUploadOrder());
  }

	hideQuickAdd() {
		this.store.dispatch(new CloseQuickAdd());
	}


	quickProductSelect(product) {
		this.router.navigate(['/shop', 'product', product.productCode])
  }


  chunkedDisplay(errors: UploadOrderItemError[], chunkSize = 25): void {
    this.uploadInProgress = true;
    this.uploadProgress = 0;
    this.uploadErrors = [];
    this.cdRef.detectChanges();

    let index = 0;
    const total = errors.length;

    const loadChunk = () => {
      const next = errors.slice(index, index + chunkSize);
      this.uploadErrors.push(...next);


      index += chunkSize;
      this.uploadProgress = Math.round((index / total) * 100);
      this.cdRef.detectChanges();

      if (index < total) {
        setTimeout(loadChunk, 50); // short delay for smoother animation
      } else {
        setTimeout(() => {
          this.uploadInProgress = false;
          this.uploadPhase = 'complete';
          this.currentProductCode = '';
          this.cdRef.detectChanges();
        }, 500);
      }
    };

    loadChunk();
  }




  //upload(e) {
  //  this.uploadErrors = [];
  //  this.uploadInProgress = true;
  //  this.uploadProgress = 0;
  //  this.uploadPhase = 'lookup';
  //  this.cdRef.detectChanges();

  //  const file = e.srcElement.files[0];
  //  const reader = new FileReader();
  //  const codes: string[] = [];

  //  reader.onload = () => {
  //    const lines = (reader.result as string).split('\n');
  //    for (let line of lines) {
  //      if (!line.includes(',')) continue;
  //      const parts = line.split(',');
  //      const code = parts[this.uploadOrderType === 1 ? 1 : 0].trim();
  //      if (code) codes.push(code);
  //    }

  //    // ✅ Begin animating product codes
  //    let idx = 0;
  //    this.lookupInterval = setInterval(() => {
  //      this.currentProductCode = codes[idx++ % codes.length];
  //      this.cdRef.detectChanges();
  //    }, 150);

  //    // 🚀 Now perform the upload
  //    this.dataService.uploadOrderFile(this.uploadOrderType, this.removeText, file)
  //      .subscribe(resp => {
  //        clearInterval(this.lookupInterval); // ✅ stop scrolling on response
  //        this.currentProductCode = '';

  //        this.uploadFileFormField.nativeElement.value = null;

  //        if (resp.length === 0) {
  //          this.uploadProgress = 100;
  //          this.uploadPhase = 'complete';
  //          setTimeout(() => {
  //            this.uploadInProgress = false;
  //            this.store.dispatch(new HideUploadOrder());
  //            this.store.dispatch(new SuccessMessageSet("Your file was uploaded without errors"));
  //          }, 600);
  //        } else {
  //          this.chunkedDisplay(resp);
  //        }

  //        this.store.dispatch(new GetCart());
  //      });
  //  };

  //  reader.readAsText(file);
  //}




  upload(e) {
    this.uploadErrors = [];
    this.uploadInProgress = true;
    this.uploadProgress = 0;
    this.uploadPhase = 'lookup';
    this.cdRef.detectChanges();

    const file: File = e.target.files[0];
    const fileExt = file.name.split('.').pop()?.toLowerCase();
    const codes: string[] = [];

    const processCodes = (rows: any[][]) => {
      if (!rows || rows.length === 0 || rows[0].length < 2) {
        this.uploadErrors.push({ productCode: 'N/A', reason: 'File format invalid. Must have at least two columns.' });
        this.uploadPhase = 'complete';
        this.uploadInProgress = false;
        this.cdRef.detectChanges();
        return;
      }

      const firstRow = rows[0].map(cell => String(cell || '').toLowerCase());
      const hasHeaders = firstRow[0].includes('code') || firstRow[1].includes('qty');
      const dataRows = hasHeaders ? rows.slice(1) : rows;

      for (let row of dataRows) {
        const cell = row[this.uploadOrderType === 1 ? 1 : 0];
        const code = (typeof cell === 'string' ? cell.trim() : String(cell || '').trim());
        if (code) codes.push(code);
      }

      if (codes.length === 0) {
        this.uploadErrors.push({ productCode: 'N/A', reason: 'No valid product codes found in file.' });
        this.uploadPhase = 'complete';
        this.uploadInProgress = false;
        this.cdRef.detectChanges();
        return;
      }

      let idx = 0;
      this.lookupInterval = setInterval(() => {
        this.currentProductCode = codes[idx++ % codes.length];
        this.cdRef.detectChanges();
      }, 150);

      this.dataService.uploadOrderFile(this.uploadOrderType, this.removeText, file)
        .subscribe(resp => {
          clearInterval(this.lookupInterval);
          this.currentProductCode = '';
          this.uploadFileFormField.nativeElement.value = null;
          if (resp.length === 0) {
            this.uploadProgress = 100;
            this.uploadPhase = 'complete';

            setTimeout(() => {
              this.uploadInProgress = false;
              this.cdRef.detectChanges();

              setTimeout(() => {
                this.store.dispatch(new HideUploadOrder());
                this.store.dispatch(new SuccessMessageSet("Your file was uploaded without errors"));
              }, 2000); // delay before closing
            }, 800); // brief pause to finish progress bar animation
          } else {
            this.chunkedDisplay(resp);
          }

          this.store.dispatch(new GetCart());
        });
    };

    if (fileExt === 'xls' || fileExt === 'xlsx') {
      const reader = new FileReader();
      reader.onload = (ev: any) => {
        const data = new Uint8Array(ev.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const rows = XLSX.utils.sheet_to_json<any[]>(sheet, { header: 1 }) as any[][];
        processCodes(rows);
      };
      reader.readAsArrayBuffer(file);
    } else {
      const reader = new FileReader();
      reader.onload = () => {
        const rows = (reader.result as string).split('\n')
          .map(line => line.split(',').map(col => col.trim()))
          .filter(parts => parts.length >= 2);
        processCodes(rows);
      };
      reader.readAsText(file);
    }
  }







  uploadOrder() {
	this.store.dispatch(new ShowUploadOrder());
}


}
